module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/CMD-02a18effb056f19d4495f970556b0b35.svg";